module.exports = __webpack_public_path__ + "assets/img/basic-pu-fitflex.ab4a3e0f.png";